import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { fetchRoutes } from "../../api/routes";

export function useFetchRoutes(page = 1, pageSize = 10, filters = {}) {
  return useQuery({
    queryKey: ["routes", page, pageSize, filters],
    queryFn: () => fetchRoutes(page, pageSize, filters),
    onError: (err) => console.error("Error loading routes:", err),
    placeholderData: keepPreviousData,
  });
}